import { render, staticRenderFns } from "./VehicleJobInfoCard.vue?vue&type=template&id=1468fbba&scoped=true&"
import script from "./VehicleJobInfoCard.vue?vue&type=script&lang=js&"
export * from "./VehicleJobInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./VehicleJobInfoCard.vue?vue&type=style&index=0&id=1468fbba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1468fbba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
